import { Dispatch } from 'react';

import { api, ROUTES } from '../../../services/api';
import { ReduxReducers } from '../../reducers';
import { USERS_ACTIONS } from './index';
import ERRORS from '../../../constants/errors.constants';
import { AxiosError, AxiosResponse } from 'axios';
import { IndexUsersResponse, User } from '../../../typings';

const fetchUsers = (
    page = 1,
    perPage = 10, 
    callback?: (err: any, message?: string) => void,
) => {
    return async (dispatch: Dispatch<any>, getState: () => ReduxReducers) => {
        try {
            const { token } = getState().auth;

            dispatch({
                type: USERS_ACTIONS.FETCH_USERS,
            });

            const response = await api.get<
                IndexUsersResponse, 
                AxiosResponse<IndexUsersResponse>
            >
            (`${ROUTES.USERS.INDEX}`, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                const users: User[] = [];

                response?.data?.data.forEach(u => {
                    users.push({ ...u?.user, ...u?.userData, permissions: u?.permissions });
                });

                dispatch({
                    type: USERS_ACTIONS.FETCH_USERS_SUCCESS,
                    payload: users,
                });
                return callback && callback(false, '');
            }

        } catch (error: any) {
            if (error.response) {
                const ERROR_CODE = (error as AxiosError<
                    IndexUsersResponse
                >).response?.data?.errors[0];
                dispatch({
                    type: USERS_ACTIONS.FETCH_USERS_FAILED,
                });
                return callback && callback(true, ERRORS[ERROR_CODE!]);
            }

            dispatch({
                type: USERS_ACTIONS.FETCH_USERS_FAILED,
            });
            return callback && callback(true, String(error));
        }
    }
}

export default fetchUsers;